module.exports = __webpack_public_path__ + "img/003.fa212391.jpg";